module.exports = __webpack_public_path__ + "static/media/under-water.8f21163c.jpg";